import {useMessages} from "i18n";
import Seo from "../seo/Seo";
import {Unsubscribe} from "../unsubscribe/Unsubscribe";

/**
 * Public route wrapper for `/unsubscribe/offers` (kitecorp/transferify#163) — the target of the
 * unsubscribe link in a MARKETING message.
 *
 * A separate route from `/unsubscribe` rather than a query flag: the api endpoints behind the two are
 * different (this one writes an account preference, that one the recipient suppression list), and a flag
 * would put the choice between them in a parameter anybody can edit. Pre-rendered as a SHELL for the same
 * reason as its sibling — the token travels in the query string — and `noindex` because the page means
 * nothing without one.
 */
export function Component() {
	const {unsubscribe} = useMessages();
	return (
		<>
			<Seo
				title={unsubscribe.marketing.seoTitle}
				description={unsubscribe.marketing.seoDescription}
				path="/unsubscribe/offers"
				noindex
			/>
			<Unsubscribe scope="marketing"/>
		</>
	);
}
